











import FeedbackComponent from '@/components/base/FeedbackComponent'
import {StoreNamespace} from "@/globals/StoreNamespaceGlobal";
import {GridColumn} from '@payroll/grid-widget/src/models/GridColumn'
import {KeyValuePair} from "@payroll/optimus-common";
import {FieldType, SearchFieldModel} from "@payroll/search-results-widget/src/models/SearchField.model";
import Component from 'vue-class-component'
import {Prop} from 'vue-property-decorator'
import {Action} from "vuex-class";

@Component({})
export default class MemberTransactionsGrid extends FeedbackComponent {

  @Prop(String) memberIdNum!: string;
  @Prop() memberAccounts!: [];

  @Action('fetchMemberTransactions', StoreNamespace.CUSTOMER_SERVICE) fetchMemberTransactions: any;

  private searchFields: SearchFieldModel[] = []
  private columns: GridColumn[] = [];
  private correctDate: string = ''
  private years: KeyValuePair[] = []
  private currentMemberAccounts: KeyValuePair[] = []

  mounted() {

    this.initYears()
    this.initSearchFields()
    this.initColumns();

  }

  private initYears() {
    const currentYear = new Date().getFullYear();
    const startYear = 2014;

    for (let i = currentYear; i >= startYear; i--) {
      this.years.push(
          {key: i + "", description: i + ""} as unknown as KeyValuePair
      )
    }
  }


  private initSearchFields(): void {
    const seenAccountNums = new Set();
    const currentAccounts = this.memberAccounts
        .filter((memberAccount: any) => memberAccount.accountNumHashed !== null)
        .map((memberAccount: any) => {
          return { key: memberAccount.accountNum, description: memberAccount.accountNum }
        })
        .filter((account) => {
          const isDuplicate = seenAccountNums.has(account.key);
          seenAccountNums.add(account.key);
          return !isDuplicate;
        });

    this.searchFields.push({
      label: 'MemberTransactions.year',
      property: 'year',
      fieldType: FieldType.SELECT_FIELD,
      selectOptions: this.years,
      unSelectFirst: true,
    })
    this.searchFields.push({
      label: 'MemberTransactions.accountNum',
      property: 'accountNum',
      fieldType: FieldType.SELECT_FIELD,
      selectOptions: currentAccounts,
      unSelectFirst: false,
      dontAddDefaultSelect: true,
    })
  }

  initColumns(): void {
    this.columns.push({property: 'fundNum', header:'MemberTransactions.fund'} as GridColumn)
    this.columns.push({property: 'accountNum', header:'MemberTransactions.accountNum'} as GridColumn)
    this.columns.push({property: 'depositDate', header:'MemberTransactions.depositDate'} as GridColumn)
    this.columns.push({property: 'monthOfSalary', header:'MemberTransactions.monthOfSalary'} as GridColumn)
    this.columns.push({property: 'salary', header:'MemberTransactions.salary', hideSorting: true} as GridColumn)
    this.columns.push({property: 'inputMemberProceeds', header:'MemberTransactions.inputMemberProceeds'} as GridColumn)
    this.columns.push({property: 'inputEmployerProceeds', header:'MemberTransactions.inputEmployerProceeds'} as GridColumn)
    this.columns.push({property: 'inputEmployerCompensations', header:'MemberTransactions.inputEmployerCompensations'} as GridColumn)
    this.columns.push({property: 'totalDeposits', header:'MemberTransactions.totalDeposits', hideSorting: true} as GridColumn)
  }


  onSuccess(data?: any, requestName?: string, message?: string, success?: boolean): void {
    switch (requestName) {
      case 'findMembersOrEmployersFor/transactions':
        this.$emit('successResults', data)
        break;
    }

  }


  private fetchGridData(searchObject: any): void {
    console.log("searchObject", searchObject)
    searchObject.pageSize = -1

    this.fetchMemberTransactions({
      requestorCallback: this,
      requestBody: searchObject,
    });
  }

}


